import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PromoBanner from '../components/PromoBanner';
import SEO from '../components/SEO';
import { Bell } from 'lucide-react';

const ZeroToCloudAcceleratorPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50">
      <SEO 
        title="Zero To Cloud Accelerator"
        description="Zero To Cloud Accelerator program - Currently not accepting enrollments. Subscribe to our newsletter for updates."
        keywords="AWS accelerator program, cloud career accelerator, AWS training program"
        url="https://www.zerotocloud.co/accelerator"
      />
      <PromoBanner />
      <Navigation />

      {/* Main Content */}
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-3xl mx-auto text-center">
          {/* Icon */}
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-blue-100">
              <Bell size={48} className="text-blue-600" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Zero To Cloud Accelerator
          </h1>

          {/* Message */}
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8">
            <p className="text-xl md:text-2xl text-gray-700 mb-6 leading-relaxed">
              We are currently <span className="font-semibold text-blue-600">not accepting enrollments</span> for the Zero To Cloud Accelerator program.
            </p>
            
            <p className="text-lg text-gray-600 mb-8">
              Want to be notified when we open enrollments again?
            </p>

            {/* CTA Button */}
            <a
              href="https://www.cloudbites.ai/subscribe"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-lg transition-all duration-200"
            >
              <Bell size={20} />
              Subscribe to Newsletter for Updates
            </a>
          </div>

          {/* Additional Info */}
          <p className="text-gray-600">
            In the meantime, check out our <a href="/courses" className="text-blue-600 hover:underline font-medium">self-paced courses</a> to start your cloud journey today.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ZeroToCloudAcceleratorPage;
